import { DatePipe } from '@angular/common'
import { Pipe, PipeTransform } from '@angular/core'

import { EM_DASH } from '../../../constants/constant.content'

@Pipe({
  name: 'customDate',
})
export class CustomDatePipe extends DatePipe implements PipeTransform {
  transform(date: any, format?: any): any {
    if (date === null || date === undefined) {
      return EM_DASH
    }
    return super.transform(date, format || 'MM/dd/yyyy')
  }
}
